var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menu-slots" },
    [
      _vm.choosing
        ? _vm._l(_vm.menu.slots.models, function (slot) {
            return _c(
              "div",
              { staticClass: "slot" },
              [
                _c("v-select", {
                  attrs: {
                    label: slot.title,
                    items: slot.variables.models,
                    "item-text": "title",
                    "item-value": "pid",
                  },
                  model: {
                    value: slot.selected,
                    callback: function ($$v) {
                      _vm.$set(slot, "selected", $$v)
                    },
                    expression: "slot.selected",
                  },
                }),
                slot.selected && slot.selected.variants.length
                  ? _c("v-select", {
                      attrs: {
                        label: "Choose Ounces",
                        items: slot.selected.variants.models,
                        "item-text": "title",
                        "item-value": "pid",
                      },
                      model: {
                        value: slot.selected.selected,
                        callback: function ($$v) {
                          _vm.$set(slot.selected, "selected", $$v)
                        },
                        expression: "slot.selected.selected",
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          })
        : _vm._l(_vm.menu.slots.models, function (slot) {
            return _c(
              "div",
              {
                staticClass: "mcnee-custom-field-row",
                attrs: { "data-type": "text-field", "data-id": slot.pid },
              },
              [
                slot.selected
                  ? [
                      slot.selected.selected
                        ? _c("input", {
                            staticClass: "mcnee-custom-field",
                            attrs: { type: "hidden", name: slot.pid },
                            domProps: { value: slot.selected.selected.pid },
                          })
                        : slot.selected.defprod
                        ? _c("input", {
                            staticClass: "mcnee-custom-field",
                            attrs: { type: "hidden", name: slot.pid },
                            domProps: { value: slot.selected.defprod.pid },
                          })
                        : slot.selected.variants.length == 0
                        ? _c("input", {
                            staticClass: "mcnee-custom-field",
                            attrs: { type: "hidden", name: slot.pid },
                            domProps: { value: slot.selected.pid },
                          })
                        : _vm._e(),
                    ]
                  : slot.defprod
                  ? [
                      slot.defprod.defprod
                        ? _c("input", {
                            staticClass: "mcnee-custom-field",
                            attrs: { type: "hidden", name: slot.pid },
                            domProps: { value: slot.defprod.defprod.pid },
                          })
                        : slot.defprod.variants.length == 0
                        ? _c("input", {
                            staticClass: "mcnee-custom-field",
                            attrs: { type: "hidden", name: slot.pid },
                            domProps: { value: slot.defprod.pid },
                          })
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            )
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }